'use strict';

angular.module('bringgApp').factory('AddTeamService', function ($q, $uibModal) {
	var AddTeamService = {};
	AddTeamService.open = function () {
		var deferred = $q.defer();

		var modalInstance = $uibModal.open({
			backdrop: 'static',
			keyboard: true,
			controller: 'AddTeamController',
			templateUrl: 'scripts/features/add_team/add-team.html'
		});

		modalInstance.result.then(
			function (result) {
				deferred.resolve(result);
			},
			function (reason) {
				deferred.reject();
			}
		);

		return deferred.promise;
	};

	return AddTeamService;
});
